import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { flow, property } from 'lodash';

import AccountsAbroad from '../components/AccountsAbroad';
import { startRequest as getAccountsAbroad } from '../redux/accountsAbroad/actions';
import { bindActionCreators } from 'redux';

import config from '../../../config';

export default connect(
  createStructuredSelector({
    config: () => config,
    accountsAbroad: createStructuredSelector({
      data: flow(property('profile.accountsAbroad'), (accountsAbroad) =>
        accountsAbroad.get('data'),
      ),
      loading: flow(property('profile.accountsAbroad'), (accountsAbroad) =>
        accountsAbroad.get('loading'),
      ),
      error: flow(property('profile.accountsAbroad'), (accountsAbroad) =>
        accountsAbroad.get('error'),
      ),
    }),
    accountsAbroadListFilters: createStructuredSelector({
      accountStatus: flow(property('profile.accountsAbroadListFilters'), (filters) =>
        filters.get('accountStatus'),
      ),
      bank: flow(property('profile.accountsAbroadListFilters'), (filters) => filters.get('bank')),
    }),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        loadAccountsAbroad: getAccountsAbroad,
      },
      dispatch,
    ),
)(AccountsAbroad);
